import {GitCommitIcon} from '@primer/octicons-react'
import {useSuspenseActivityPageData} from '../../data/use-activity-page-data'
import {SidebarActivityRow} from './SidebarActivityRow'
import {hasCommits, pluralize} from './activity-row-helpers'

export function CommitsRow() {
  const {summary} = useSuspenseActivityPageData()
  if (!hasCommits(summary)) return null

  const n = summary?.commits?.count ?? 0
  const label = `${n} new ${pluralize(n, 'commit', 'commits')}`

  return (
    <SidebarActivityRow icon={GitCommitIcon} categoryLabel="Commits" label={label} group="commits" expectedCount={n} />
  )
}
